/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// api
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';

// mantine
import { notifications } from '@mantine/notifications';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { TCertificate } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const sendCertificate = (data: {
	certificateId: string;
	email?: string;
}): Promise<TCertificate> => {
	return apiClient.post(
		`/certificates/send/${data.certificateId}`,
		{ ...(data.email ? { email: data.email } : {}) }
	);
};

export const useSendCertificate = () => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: sendCertificate,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					`notifications.certificateSuccessfullySended`
				),
				color: 'success',
			});
		},
		onError: (error: { type: string }) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading, isSuccess, data };
};
